"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegalTerms() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const companyDetails = [{
    label: "Ragione Sociale",
    value: "Aera Sanum"
  }, {
    label: "Sede Legale",
    value: "Via dell'Ingegneria, 12 - 00100 Roma (RM)"
  }, {
    label: "P.IVA / C.F.",
    value: "01234567890"
  }, {
    label: "Telefono",
    value: "+39 06 1234567"
  }, {
    label: "Email",
    value: "segreteria.aera@hotmail.com"
  }, {
    label: "Settori Operativi",
    value: "Bonifica tecnica HVAC, Cappe professionali, Sistemi di aspirazione industriale"
  }];
  const disclaimers = [{
    title: "Esclusione di Responsabilità",
    text: "Le informazioni riportate su questo sito hanno scopo puramente informativo e tecnico. Aera Sanum si impegna a mantenere i contenuti aggiornati, tuttavia non garantisce l'assoluta esattezza o completezza delle informazioni fornite in merito a specifiche normative locali o evoluzioni tecniche repentine."
  }, {
    title: "Proprietà Intellettuale",
    text: "Tutti i contenuti, i marchi, i loghi e le immagini presenti su questo sito sono di proprietà esclusiva di Aera Sanum o dei rispettivi licenziatari. È vietata la riproduzione, anche parziale, senza autorizzazione scritta."
  }, {
    title: "Documentazione Tecnica e Immagini",
    text: "Le immagini relative a interventi di bonifica, robotica e strumentazione tecnica sono rappresentative degli standard operativi della divisione. I report fotografici citati nelle sezioni del sito sono documenti riservati forniti esclusivamente ai committenti a seguito dell'intervento."
  }, {
    title: "Link a Terze Parti",
    text: "Il sito può contenere collegamenti a siti web esterni gestiti da terzi. Aera Sanum non esercita alcun controllo su tali siti e non si assume alcuna responsabilità per i loro contenuti o per le loro politiche sulla privacy."
  }, {
    title: "Trattamento dei Dati",
    text: "Il trattamento dei dati personali raccolti attraverso il sito avviene nel pieno rispetto del Regolamento UE 2016/679 (GDPR). Per maggiori dettagli, consultare le informative dedicate."
  }];
  return <section data-section-id="2319" id="legalterms" className="bg-white text-secondary py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="mx-auto max-w-4xl px-6 lg:px-12">
        <div ref={contentRef} className={`transition-all duration-[1200ms] ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="mb-16">
            <p className="font-mono text-[11px] uppercase font-medium mb-6" style={{
            color: "var(--accent)",
            letterSpacing: "0.25em"
          }}>
              [INFO_LEGAL_01]
            </p>
            <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl font-semibold text-primary mb-8" style={{
            lineHeight: 1.1
          }}>
              Note legali
            </h1>
            <p className="font-default text-lg text-muted-foreground leading-relaxed max-w-3xl">
              Aera Sanum opera come divisione tecnica specializzata nella riqualificazione igienico-funzionale di impianti aeraulici e sistemi di aspirazione professionale. La presente sezione definisce i termini di utilizzo del portale e le informazioni societarie obbligatorie.
            </p>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 py-12 border-y border-border mb-16">
            {companyDetails.map((detail, i) => <div key={i} data-index={i} className="flex flex-col gap-1">
                <span className="font-mono text-[10px] uppercase text-accent tracking-wider">
                  {detail.label}
                </span>
                <span className="font-default text-base text-secondary font-medium">
                  {detail.value}
                </span>
              </div>)}
          </div>

          {}
          <div className="space-y-12 mb-20">
            {disclaimers.map((item, i) => <div key={i} data-index={i} className="max-w-3xl">
                <h2 className="font-default text-xl font-semibold text-primary mb-4">
                  {item.title}
                </h2>
                <p className="font-default text-base text-muted-foreground leading-relaxed">
                  {item.text}
                </p>
              </div>)}
          </div>

          {}
          <div className="flex flex-wrap gap-8 pt-8 border-t border-border">
            <Link to="#" className="group font-default text-sm font-medium text-primary inline-flex items-center gap-2">
              <span className="relative">
                Privacy Policy
                <span className="absolute left-0 -bottom-0.5 h-px w-full bg-primary origin-left scale-x-100 group-hover:scale-x-0 transition-transform duration-500 ease-out" />
              </span>
            </Link>
            <Link to="#" className="group font-default text-sm font-medium text-primary inline-flex items-center gap-2">
              <span className="relative">
                Cookie Policy
                <span className="absolute left-0 -bottom-0.5 h-px w-full bg-primary origin-left scale-x-100 group-hover:scale-x-0 transition-transform duration-500 ease-out" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}